import axios from "axios"
import { Message } from "element-ui"

const TOKEN_KEY = "starlive_guild_token"

export const getGuildToken = () => localStorage.getItem(TOKEN_KEY) || ""
export const setGuildToken = token => localStorage.setItem(TOKEN_KEY, token)
export const clearGuildToken = () => localStorage.removeItem(TOKEN_KEY)

const messages = {
  "GUILD.AUTH_REQUIRED": "请先登录公会管理端",
  "GUILD.SESSION_EXPIRED": "登录已过期，请重新登录",
  "GUILD.ACCOUNT_DISABLED": "公会账号已停用",
  "GUILD.DISABLED": "公会尚未通过审核或已停用",
  "GUILD.PERMISSION_DENIED": "当前账号没有此操作权限",
  "GUILD.USER_ALREADY_EXISTS": "该用户已存在，请通过邀请加入公会",
  "GUILD.USER_CREATE_FAILED": "用户创建失败，请稍后重试",
  "GUILD.CREATOR_ALREADY_JOINED": "该主播已经加入公会",
  "GUILD.REQUEST_PENDING": "已有待处理的同类申请",
  "GUILD.SHARE_EXCEEDS_LEVEL": "直播礼物主播分成必须在 0%–80% 之间",
  "GUILD.SHARE_ADJUSTMENT_LOCKED": "平台当前已锁定直播礼物分成，公会暂时不能调整",
  "GUILD.PAYMENT_CONFIGURATION_REQUIRED": "平台尚未配置提现账号加密密钥，请联系管理员",
  "WALLET.INSUFFICIENT_BALANCE": "可提现余额不足",
  "AUTH.INVALID_CREDENTIALS": "邮箱或密码错误",
  "AUTH.TOO_MANY_ATTEMPTS": "登录失败次数过多，请稍后重试",
  "AUTH.CURRENT_PASSWORD_INVALID": "当前密码不正确",
  "AUTH.NEW_PASSWORD_SAME": "新密码不能与当前密码相同",
  "AUTH.PASSWORD_CONFIRM_MISMATCH": "两次输入的新密码不一致",
  "AUTH.PASSWORD_COMPLEXITY_REQUIRED": "新密码至少 8 位，并同时包含字母和数字",
  "AUTH.PASSWORD_UPDATE_FAILED": "密码修改失败，请稍后重试",
  "AUTH.PASSWORD_UPDATED": "密码已修改，其他设备已退出登录",
  "COMMON.NOT_FOUND": "记录不存在或已发生变化",
  "COMMON.VALIDATION_FAILED": "提交内容不符合要求"
}

function errorText(payload, fallback) {
  if (payload && String(payload.error_detail || "").trim()) return String(payload.error_detail).trim()
  const code = payload && (payload.error_code || payload.message_code || payload.msg)
  return messages[code] || fallback || "操作失败，请稍后重试"
}

const request = axios.create({
  baseURL: process.env.VUE_APP_GUILD_API_BASE_URL || "/guild/api",
  timeout: 15000,
  headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
  transformRequest: [data => {
    if (!data || (typeof FormData !== "undefined" && data instanceof FormData)) return data
    const body = new URLSearchParams()
    Object.keys(data).forEach(key => {
      if (data[key] !== null && data[key] !== undefined) body.append(key, data[key])
    })
    return body
  }]
})

request.interceptors.request.use(config => {
  const token = getGuildToken()
  if (token) config.headers.Authorization = `Bearer ${token}`
  config.headers["X-Timezone"] = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC"
  return config
})

request.interceptors.response.use(response => {
  const payload = response.data || {}
  if (Number(payload.code) !== 200) {
    if (Number(payload.code) === 401) {
      clearGuildToken()
      window.dispatchEvent(new CustomEvent("guild-auth-required"))
    }
    const error = new Error(errorText(payload))
    error.responseData = payload
    Message.error(error.message)
    return Promise.reject(error)
  }
  return payload
}, error => {
  const payload = error.response && error.response.data
  const message = errorText(payload, error.code === "ECONNABORTED" ? "请求超时，请检查网络后重试" : "网络连接异常")
  if (error.response && Number(error.response.status) === 401) {
    clearGuildToken()
    window.dispatchEvent(new CustomEvent("guild-auth-required"))
  } else {
    Message.error(message)
  }
  return Promise.reject(error)
})

export default request
